/* global G */
import { curry } from 'lib/util'
import { showBlockingDialog } from 'app/_shared/events/dialog'
import { isDate } from 'lib/util/date'


/**
 * Displays a warning dialog informing the user that a reference measurement already exists with
 * the introduced form values.
 *
 * @param module  current module
 */
const showInvalidLicenceDialog = async (module: Gaia.AppModule.Spec) => {
  return await showBlockingDialog(module, null, {
    title: {
      ns: 'apmGo',
      key: 'dialog.reportWithInvalidLicenceError.title',
      defaultValue: 'Error',
    },
    text: {
      ns: 'apmGo',
      key: 'dialog.reportWithInvalidLicenceError.text',
      defaultValue: 'A report can only be created with a valid license.'
    },
    cancel: false,
  })
}

/**
 * Shows a dialog and throws an error if the current sensor's licence is invalid.
 *
 * @param module    current module
 * @param component event source
 * @param event     triggered event
 */
const checkLicence = async (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: Gaia.PlatformEvent,
) => {
  const { sensor } = module[G.MODEL][G.CHILDREN]
  const { value } = sensor[G.CACHE]
  const { licensedUntil } = value

  const now = Date.now()
  const expiryDate = isDate(licensedUntil)
    ? new Date(licensedUntil).getTime()
    : 0

  if (expiryDate < now) {
    await showInvalidLicenceDialog(module)
    throw Error('Licence is expired')
  }
}

export default curry(checkLicence)
